import { axios } from '@/plugins/axios';
import { InfosDelegation } from '@/components/MesParametres/ParametresVaccination/ParametresDelegation/types';

export function getInfosPSBEN2() {
	return axios.get('/vaccination-covid-api/identite');
}

export function extendSession(psDelegation: InfosDelegation | undefined) {
	return axios.get(createUrlExtendSession(psDelegation));
}

function createUrlExtendSession(psDelegation: InfosDelegation | undefined): string {
	let url = '/vaccination-covid-api/session/extend';

	if (psDelegation) {
		url += '?nomDelegation=' + psDelegation.nom;
		url += '&prenomDelegation=' + psDelegation.prenom;
		url += '&dateNaissanceDelegation=' + psDelegation.dateNaissance;
	}
	return url;
}
